
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/business",
      function () {
        return require("private-next-pages/login/business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/business"])
      });
    }
  